
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../Services/payment.service';
import { MemberService } from '../../Services/member.service';
import { DOCUMENT } from '@angular/common';
import { SubscriptionService } from '../../Services/subscription.service';
import { ClothesService } from '../../Services/clothes.service';



@Component({
  selector: 'app-payment-processing',
  template: require('./payment-processing.component.html'),
  styles: [require('./payment-processing.component.css')],
})

export class PaymentProcessingComponent implements OnInit {
  
  data:string = ""
  paymentReqInfo:any = {
    "Id":-1,
    "Category": ""
  }
  paymentInfo:any={
    "firstname": "",
    "lastname": "",
    "fullprice": 0,
    "discount": 0,
    "amountToPay":0,
    "deposit":0,
    "subject":""
  }


  problemWithLink = true
  ErrorLoading = false;
  ErrorMessage = "";

  constructor(
      private route: ActivatedRoute, 
      private paymentService :PaymentService, 
      private memberService: MemberService,
      private subsciptionService: SubscriptionService,
      private clothesService:ClothesService,
      @Inject(DOCUMENT)  private document: Document){
    route.params.subscribe(p => {
      if (p['data']) {
        this.data= p['data'];
      }
      else {
        this.data = "";
      }
    });

    this.paymentService.CheckPaymentLink(this.data).subscribe( (res:any)=>{
      console.log(res)

      if (res.status == 200){
        this.problemWithLink = false;
        this.paymentReqInfo = res.value

        console.log("paymentReqInfo: ");
        
        console.log(this.paymentReqInfo);
        
        
        switch (this.paymentReqInfo.category) {
          case "subscription":
            // console.log("in subscription");
            this.memberService.subscriptionAmountForId(this.paymentReqInfo.id).subscribe( (res:any)=>{
              // console.log(res);
              if (res.status == 200)   {
                this.paymentInfo.firstname = res.value.firstname;
                this.paymentInfo.lastname = res.value.lastname;
                this.paymentInfo.fullprice = res.value.fullprice;
                this.paymentInfo.discount = res.value.discount;
                this.paymentInfo.amountToPay = res.value.amountToPay;
                this.paymentInfo.subject = res.value.subject;
                this.paymentInfo.deposit = res.value.deposit;
              }
            })
            break;
          case "eventsubscription":
              // console.log("in eventsubscription");
              this.subsciptionService.subscriptionAmountForId(this.paymentReqInfo.id).subscribe( (res:any)=>{
                // console.log(res);
                if (res.status == 200)   {
                  this.paymentInfo.firstname = res.value.firstname;
                  this.paymentInfo.lastname = res.value.lastname;
                  this.paymentInfo.fullprice = res.value.fullprice;
                  this.paymentInfo.discount = res.value.discount;
                  this.paymentInfo.amountToPay = res.value.amountToPay;
                  this.paymentInfo.subject = res.value.subject;
                  this.paymentInfo.deposit = res.value.deposit;
                }
              })
              break;
          case "eventdeposit":
              // console.log("in eventdeposit");
              this.subsciptionService.subscriptionDepositAmountForId(this.paymentReqInfo.id).subscribe( (res:any)=>{
                console.log(res);
                if (res.status == 200)   {
                  this.paymentInfo.firstname = res.value.firstname;
                  this.paymentInfo.lastname = res.value.lastname;
                  this.paymentInfo.fullprice = res.value.fullprice;
                  this.paymentInfo.discount = res.value.discount;
                  this.paymentInfo.amountToPay = res.value.amountToPay;
                  this.paymentInfo.subject = res.value.subject;
                  this.paymentInfo.deposit = res.value.deposit;
                }
              }, err =>{
                if (err.status == 404){
                  
                  this.ErrorLoading = true;
                  this.ErrorMessage =  err.text()
                  this.resetPaymentInfo()
                }
              } )
              break;
          
          case "clothespayment":
            this.clothesService.getAmountOfCartForId(this.paymentReqInfo.idString).subscribe( (res:any)=>{
              if (res.status == 200){
                this.paymentInfo.firstname = res.value.firstname;
                this.paymentInfo.lastname = res.value.lastname;
                this.paymentInfo.fullprice = res.value.fullprice;
                this.paymentInfo.discount = res.value.discount;
                this.paymentInfo.amountToPay = res.value.amountToPay;
                this.paymentInfo.subject = res.value.subject;
                this.paymentInfo.deposit = res.value.deposit;
                this.paymentInfo.data = res.value.clothes
              }
            }, err =>{
              if(err.status ==404){
                  this.ErrorLoading = true;
                  this.ErrorMessage =  err.text()
                  this.resetPaymentInfo()
              }
            })
            break;

          default:
            break;
        }
      }

    })
  }

  ngOnInit() {

  }

  resetPaymentInfo(){
    this.paymentInfo.firstname = "";
    this.paymentInfo.lastname = "";
    this.paymentInfo.fullprice = -1;
    this.paymentInfo.discount = -1;
    this.paymentInfo.amountToPay = -1;
    this.paymentInfo.subject = -1;
    this.paymentInfo.deposit = -1;
  }

  DoPayment(){
    console.log("DoPayment");
    
    var paymentinfo:any ={};

    switch (this.paymentReqInfo.category) {
      case "subscription":
          paymentinfo ={
            "amount": {
              "currency": "EUR",
              "value":  (this.paymentInfo.amountToPay).toFixed(2)
            },
            "description": "lidgeld-"+this.paymentInfo.firstname+"_"+this.paymentInfo.lastname ,
            "category": this.paymentReqInfo.category,
            "id": this.paymentReqInfo.id
          }
        break;
      case "eventsubscription":
        paymentinfo ={
          "amount": {
            "currency": "EUR",
            "value":  (this.paymentInfo.amountToPay).toFixed(2)
          },
          "description": this.paymentInfo.subject+"-"+this.paymentInfo.firstname+"_"+this.paymentInfo.lastname ,
          "category": this.paymentReqInfo.category,
          "id": this.paymentReqInfo.id
        }
        break;
        case "eventdeposit":
          paymentinfo ={
            "amount": {
              "currency": "EUR",
              "value":  (this.paymentInfo.deposit).toFixed(2)
            },
            "description": this.paymentInfo.subject+"-"+this.paymentInfo.firstname+"_"+this.paymentInfo.lastname ,
            "category": this.paymentReqInfo.category,
            "id": this.paymentReqInfo.id
          }
          break;
        case "clothespayment":
            paymentinfo ={
              "amount": {
                "currency": "EUR",
                "value":  (this.paymentInfo.amountToPay).toFixed(2)
              },
              "description": this.paymentInfo.subject+"-"+this.paymentInfo.firstname+"_"+this.paymentInfo.lastname ,
              "category": this.paymentReqInfo.category,
              "id": this.paymentReqInfo.id,
              "idString": this.paymentReqInfo.idString
            }
            break;
      default:
        break;
    }
    // console.log("PaymentInfo");
    // console.log(paymentinfo)
    // console.log("----------------------");
    // console.log(this.paymentInfo);
    // console.log("************************");
    // console.log(this.paymentReqInfo;)
    
    
    
    
    
    
    this.paymentService.initPayment(paymentinfo).subscribe( (res:any) => {
        // console.log("InitPayment");
          
        // console.log(res);
        
        if (res.status  == 200){
          // console.log(res);
          // this.router.navigate(res.value)
          this.document.location.href = res.value.checkouturl
        }
      })
      
    
    
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/payment-processing/payment-processing.component.ts